"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowanceButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const approve_json_1 = __importDefault(require("@framework/abis/json/ERC20Simple/approve.json"));
const setApprovalForAll_json_1 = __importDefault(require("@framework/abis/json/ERC1155Simple/setApprovalForAll.json"));
const utils_1 = require("../../../utils");
const dialogs_1 = require("../../../dialogs");
const dialog_1 = require("./dialog");
const AllowanceButton = (props) => {
    const { className, contract, contract: { address }, disabled, variant, disabledTokenTypes, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        const { amount, contract } = values;
        if (contract.contractType === types_1.TokenType.ERC20) {
            return writeContractAsync({
                address: contract.address,
                abi: approve_json_1.default,
                functionName: "approve",
                args: [address, amount],
            });
        }
        else if (contract.contractType === types_1.TokenType.ERC721 || contract.contractType === types_1.TokenType.ERC998) {
            return writeContractAsync({
                address: contract.address,
                abi: setApprovalForAll_json_1.default,
                functionName: "setApprovalForAll",
                args: [address, true],
            });
        }
        else if (contract.contractType === types_1.TokenType.ERC1155) {
            return writeContractAsync({
                address: contract.address,
                abi: setApprovalForAll_json_1.default,
                functionName: "setApprovalForAll",
                args: [address, true],
            });
        }
        else {
            throw new Error("unsupported token type");
        }
    });
    const handleAllowanceConfirm = async ({ data }) => {
        await metaFn(data);
    };
    const handleAllowance = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ALLOWANCE, contract, {
            initialValues: {
                tokenType: types_1.TokenType.ERC20,
                contractId: 0,
                amount: "0",
                contract: {
                    address: "",
                    contractType: types_1.TokenType.ERC20,
                    decimals: 18,
                },
            },
            validationSchema: dialog_1.allowanceValidationSchema,
            message: "dialogs.allowance",
            testId: "AllowanceForm",
            onExternalConfirm: handleAllowanceConfirm,
            componentProps: {
                disabledTokenTypes,
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleAllowance, icon: icons_material_1.HowToVote, message: "form.buttons.allowance", className: className, dataTestId: "AllowanceButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract), variant: variant }));
};
exports.AllowanceButton = AllowanceButton;
//# sourceMappingURL=index.js.map